import React, { useEffect } from "react";
import { Form, Input, Button, Drawer } from "antd";
import IntlMessages from "util/IntlMessages";
import {
  useAddLicensorMutation,
  useUpdateLicensorMutation,
} from "../../appRedux/api/adminPartnerApi";

const LicensorDrawer = ({ visible, onClose, editMode = false, licensor = null }) => {
  const [form] = Form.useForm();
  const [addLicensor, { isLoading: isAdding }] = useAddLicensorMutation();
  const [updateLicensor, { isLoading: isUpdating }] = useUpdateLicensorMutation();
  const isSaving = isAdding || isUpdating;

  useEffect(() => {
    if (!visible) return;
    if (editMode && licensor) {
      form.setFieldsValue({ name: licensor.name, email: licensor.email });
    } else {
      form.resetFields();
    }
  }, [visible, editMode, licensor, form]);

  const onFinish = async (values) => {
    const data = {
      name: values.name,
      email: values.email ? values.email.toLowerCase() : "",
    };

    try {
      if (editMode && licensor) {
        await updateLicensor({ id: licensor.id, data }).unwrap();
      } else {
        await addLicensor(data).unwrap();
      }
      form.resetFields();
      onClose();
    } catch (error) {
      console.error("Failed to save licensor:", error);
    }
  };

  const handleClose = () => {
    if (isSaving) return;
    form.resetFields();
    onClose();
  };

  return (
    <Drawer
      title={editMode ? "Edit Licensor" : "Add Licensor"}
      placement="right"
      width={480}
      onClose={handleClose}
      open={visible}
      className="product-drawer"
      closable={!isSaving}
      maskClosable={!isSaving}
      footer={
        <div className="drawer-footer">
          <Button onClick={handleClose} style={{ marginRight: 8 }} disabled={isSaving}>
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            onClick={() => form.submit()}
            loading={isSaving}
          >
            {editMode ? "Save" : "Add Licensor"}
          </Button>
        </div>
      }
    >
      <Form
        layout="vertical"
        form={form}
        name="licensor-form"
        onFinish={onFinish}
        scrollToFirstError
        className="partner-form"
      >
        <Form.Item
          name="name"
          label="Licensor Name"
          rules={[
            {
              required: true,
              message: "Please enter the licensor name",
            },
          ]}
        >
          <Input placeholder="e.g. ViiV, Gilead" />
        </Form.Item>

        <Form.Item
          name="email"
          label="E-mail"
          rules={[
            {
              type: "email",
              message: <IntlMessages id="error.email_valid" />,
            },
            {
              required: true,
              message: <IntlMessages id="error.email_required" />,
            },
          ]}
        >
          <Input placeholder="Enter email" />
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default LicensorDrawer;
